import getImageUrlWithoutQuery from 'commons/getImageUrlWithoutQuery';

const getValidImageUrls = (images, brokenImageUrls) =>
  images.filter(({ src, fallbackSrc }) => {
    const cleanImageUrl = getImageUrlWithoutQuery(src);

    if (!cleanImageUrl) {
      return false;
    }

    // Remove any broken images from the array passed to the gallery modal
    if (!brokenImageUrls.includes(cleanImageUrl)) {
      return true;
    }

    // A photo with a broken src can still render via its fallbackSrc (Cylindo
    // thumbnails, CON-8451) - drop it when there is no fallback, or the fallback
    // is broken too. Guard the empty case: getImageUrlWithoutQuery feeds new URL(),
    // which throws on '' (studio/non-Cylindo photos have no fallbackSrc).
    if (!fallbackSrc) {
      return false;
    }

    const cleanFallbackUrl = getImageUrlWithoutQuery(fallbackSrc);
    return !!cleanFallbackUrl && !brokenImageUrls.includes(cleanFallbackUrl);
  });

export default getValidImageUrls;
